import api from 'api';

const url = 'api/profile';

export default {
    get: () => api.get({path: url})
}